import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import {
  INTERNAL_EVENTS_INDEX,
  INTERNAL_EVENTS_VIEW,
} from '../../../router/routes';
import Event from '../../../interfaces/event';
import { EventStatus } from '../../../enums/event-status';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import Form, { SubmitType } from '../../../components/form';
import Button from '../../../components/form/elements/button';
import Link from '../../../components/form/elements/link';
import useEventForm, { eventSchema } from './use-event-form';

export default function CreateEvent() {
  const { t } = useTranslation();
  const history = useHistory();
  const { eventService } = useService();
  const body = useEventForm('create');
  const footer = [Button('create'), Link(INTERNAL_EVENTS_INDEX, 'cancel')];

  const submit = useCallback<SubmitType<Event>>(
    (form) => [
      eventService.store({
        ...form,
        time: moment(form.time).format('HH:mm:ss'),
      }),
      (response) =>
        history.push(route(INTERNAL_EVENTS_VIEW, { id: response.id })),
    ],
    [eventService, history]
  );

  return (
    <Form
      title={t('pages.internal.events.form.create')}
      mode={'create'}
      body={body}
      footer={footer}
      values={{ status: EventStatus.PUBLIC }}
      submit={submit}
      schema={eventSchema}
    />
  );
}
